import { VideoScriptPage } from "@/containers/Admin";
import { VideoScriptsTable } from "@/containers/Admin/VideoScripts/components/VideoScriptsTable";
import * as React from "react";

type Props = {
  tab?: string;
  id?: string;
};

const ScriptsTab: React.FC<Props> = ({ id }) => {
  if (id) {
    return <VideoScriptPage embedded />;
  } else {
    return <VideoScriptsTable />;
  }
};

export default ScriptsTab;
